// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mFEO","footer":"styles_footer__dYxTx"};